import { defaultLocaleId } from '@shared/localization/localization.constants';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const defaultTimezone = 'America/New_York';

export function parseUTC(value: string | number) {
  return dayjs.utc(value).toDate();
}

export function convertUTCtoDefaultTimezone(value: string | number) {
  return parseUTC(value).toLocaleString(defaultLocaleId, { timeZone: defaultTimezone });
}

export function toUTCAPIDateTimeString(
  value: string | number | undefined,
  timezone = defaultTimezone,
) {
  return dayjs.utc(dayjs.tz(value, timezone)).format('YYYY-MM-DDTHH:mm:ss');
}
